window.EC_COLORS=[
['antracita', '#4A4A4A'], ['gris', '#8F8B83'], ['blanco', '#EDE7DA'], ['negro', '#26241F'],
['roble', '#B48A5C'], ['crema', '#E4D6BE'], ['beige', '#D8C3A2'], ['taupe', '#8B7D6B'],
['navy', '#2C3E57'], ['azul', '#3E5A73'], ['verde', '#6E7D5B'], ['terracota', '#B4633D'],
['burdeos', '#6E2A33'], ['vison', '#8B5E3C'], ['marron', '#8B5E3C']
];;window.EC_TYPES={
novedades: [
['Muebles de TV', /mueble tv|mueble de tv|mesa de tv/],
['Aparadores y vitrinas', /aparador|vitrina/],
['Estanterías y libreros', /estanter[ií]a|librer/],
['Muebles auxiliares', /mueble auxiliar/],
['Mesitas de noche', /mesita de noche|mesa de noche/],
['Mesas de centro', /mesas? de centro/],
['Mesas de comedor', /mesa de comedor|mesa redonda|mesa rectangular|mesa extensible|mesa /],
['Cómodas y gaveteros', /c[oó]moda|gavet/],
['Escritorios', /escritorio/],
['Camas', /\bcama|cabecero|nido/],
['Sillones', /sill[oó]n/],
['Taburetes', /taburete|banqueta/],
['Sillas', /\bsilla\b|silla /]
],
dormitorio: [
['Accesorios para gaveteros', /\bvidrio\b|cambiador|skubb|kuggis|jattebjorn|barndrom|komplement|pluring|purrpingla|dronas|bollosund/],
['Peinadoras', /peinadora|tocador/],
['Mesitas de noche', /mesita de noche|mesa de noche/],
['Cómodas y gaveteros', /gavet|c[oó]moda|cajoner/],
['Camas y cabeceros', /\bcama|cabecero|respaldar|daybed|litera|somier|colch[oó]n|baranda/]
],
salon: [
['Muebles de TV', /mueble de tv|mesa de tv|mueble tv|\btv\b|televis|entretenimiento/],
['Sofás', /sof[aá]|chaise|seccional|modular|futon|fut[oó]n/],
['Sillones y butacas', /sill[oó]n|butaca|poltrona/],
['Mesas de centro', /mesas? de centro|mesas? centro|coffee/],
['Mesas auxiliares', /mesa auxiliar|auxiliar|mesa lateral|mesa nido/],
['Estanterías', /estanter[ií]a|librer|vitrina|repisa|estante/]
]};
